import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import QrCodeScannerOutlinedIcon from '@mui/icons-material/QrCodeScannerOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';

/**
 * Elegir el modo de ingreso de datos antes de empezar a contar. Por ahora
 * solo el modo manual esta implementado (Fase 3); escaner fisico y camara
 * se agregan en la Fase 4 sobre esta misma pantalla.
 */
const MethodSelectionScreen = () => {
  const navigate = useNavigate();
  const { companyId, sessionId } = useParams<{ companyId: string; sessionId: string }>();

  const goToCounting = (method: 'manual' | 'scanner' | 'camera') => {
    navigate(`/dashboard/counting/count/${companyId}/${sessionId}/${method}`);
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh" px={3}>
      <Card sx={{ maxWidth: 480, width: '100%' }}>
        <CardContent sx={{ py: 5 }}>
          <Typography variant="h5" fontWeight={600} gutterBottom textAlign="center">
            ¿Cómo vas a contar?
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 3 }}>
            Elige el método de ingreso de datos para esta sesión.
          </Typography>

          <Stack spacing={2}>
            <Button
              variant="contained"
              size="large"
              startIcon={<EditNoteOutlinedIcon />}
              onClick={() => goToCounting('manual')}
            >
              Ingreso manual
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<QrCodeScannerOutlinedIcon />}
              onClick={() => goToCounting('scanner')}
            >
              Escáner físico
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<CameraAltOutlinedIcon />}
              onClick={() => goToCounting('camera')}
            >
              Cámara
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default MethodSelectionScreen;
